module.exports = __webpack_public_path__ + "img/bg-building.a4d1948e.png";